const styles = () => ({
  page: {
    backgroundColor: '#FAF7F1',
  },
});

export default styles;
